import { render, staticRenderFns } from "./response-comment-modify.vue?vue&type=template&id=708559bb&"
import script from "./response-comment-modify.vue?vue&type=script&lang=js&"
export * from "./response-comment-modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports